<template>
  <div class="award">
    <div class="award-contanier" v-if="!dialogVisible">
      <div class="tab">
        <div :class="active == index? 'active': ''" v-for="(item, index) in tab" :key="index" @click="switchover(index)">{{item}}</div>
      </div>

      <el-form status-icon :model="awardInfo" :rules="rules" ref="awardInfo" label-width="118px" class="award-form" style="margin: 40px 0 20px;" label-position="left">
        <div v-if="active == 0" >
          <el-form-item prop="projectCode" label="证书编号">
            <el-input size="small" v-model.trim="awardInfo.projectCode" placeholder="请输入证书编号(必须精确输入至R/D)" maxlength="20" ></el-input>
          </el-form-item>
          <el-form-item label="完成单位/完成人">
            <el-radio-group v-model="awardInfo.projectRadio" @input="handleInput">
              <el-radio :label="1">完成单位名称</el-radio>
              <el-radio :label="2">完成人姓名</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="完成单位全称" v-if="awardInfo.projectRadio == 1">
            <el-input size="small" v-model.trim="awardInfo.projectUnit" placeholder="请输入完成单位全称" ></el-input>
          </el-form-item>
          <el-form-item label="完成人全称" v-if="awardInfo.projectRadio == 2">
            <el-input size="small" v-model.trim="awardInfo.projectName" placeholder="请输入完成人全称" ></el-input>
          </el-form-item>
          <el-form-item label="申报年份" v-if="awardInfo.projectRadio">
            <el-select size="small" v-model="awardInfo.projectYear" placeholder="请选择申报年份" style="width: 100%;" clearable>
              <el-option :label="item.particularYear" :value="item.id" v-for="(item, index) in yearList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="active == 1" >
          <el-form-item prop="personalCode" label="证书编号">
            <el-input size="small" v-model.trim="awardInfo.personalCode" placeholder="请输入证书编号(必须精确所有编号)" maxlength="12"></el-input>
          </el-form-item>
          <el-form-item label="姓名" >
            <el-input size="small" v-model.trim="awardInfo.personalName" placeholder="请输入姓名" ></el-input>
          </el-form-item>
          <el-form-item label="获奖者单位" >
            <el-input size="small" v-model.trim="awardInfo.personalUnit" placeholder="请输入获奖者单位" ></el-input>
          </el-form-item>
          <el-form-item label="申报年份" >
            <el-select size="small" v-model="awardInfo.personalYear" placeholder="请选择申报年份" style="width: 100%;" clearable>
              <el-option :label="item.particularYear" :value="item.id" v-for="(item, index) in yearList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="margin: 40px 0 20px; text-align: center;">
          <el-button size="small" style="width: 100%; " type="primary" :loading="awardInfo.loading" @click="handleSearch">查询</el-button>
        </div>
      </el-form>
    </div>
    <div class="award-info-contanier" v-else>
      <div class="award-info-title">{{ active == 1 ? '个人奖查询结果' : '项目奖查询结果' }}</div>
      <div class="award-info">
        <el-form label-width="100px">
          <div class="award-info-item" v-for="(item, index) in list" :key="index">
            <div v-if="active == 1">
              <el-form-item label="奖励类别：">
                {{ item.awardType }}
              </el-form-item>
              <el-form-item label="获奖者：" >
                <span class="span">{{ item.name }}</span>
              </el-form-item>
              <el-form-item label="获奖者单位：" >
                <span class="span">{{ item.unit }}</span>
              </el-form-item>
              <el-form-item label="证书编号：">{{ item.code }}</el-form-item>
            </div>
            <div v-else>
              <el-form-item label="项目类别：">
                <span v-if="item.awardType == 1">科技进步奖</span>
                <span v-if="item.awardType == 2">技术发明奖</span>
              </el-form-item>
              <el-form-item label="项目名称：">
                <span class="span">{{ item.name }}</span>
              </el-form-item>
              <el-form-item label="获奖单位：" v-if="item.unirName">
                <span class="span">{{ item.unirName }}</span>
              </el-form-item>
              <el-form-item label="获奖人：" v-if="item.peopleName">
                <span class="span">{{ item.peopleName }}</span>
              </el-form-item>
              <el-form-item label="获奖等级：">
                <span v-if="item.awardsLv === 0">特等奖</span>
                <span v-if="item.awardsLv === 1">一等奖</span>
                <span v-if="item.awardsLv === 2">二等奖</span>
                <span v-if="item.awardsLv === 3">三等奖</span>
              </el-form-item>
              <el-form-item label="证书编号：">{{ item.code }}</el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div style="padding: 20px 0; text-align: center;">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { increasedPersonalGetBatchYears, increasedProjectGetGenerate, increasedPersonageGetGenerate } from '@/api/increased'
export default {
  data() {
    const validateProjectCode = (rule, value, callback) => {
      if (value) {
        setTimeout(() => {
          const reg = /^(PRO|IN)-(CE|CT|EI)-(S|A|B|C)-\d{7}-(D|R)\d{2}$/
          if (!reg.test(value)) {
            return callback(new Error('证书编号格式错误'))
          }
          callback()
        }, 300)
      } else {
        callback()
      }
    }
    const validatePersonalCode = (rule, value, callback) => {
      if (value) {
        setTimeout(() => {
          const reg = /^(TA|YIA)-\d{4}-\d{3}$/
          if (!reg.test(value)) {
            return callback(new Error('证书编号格式错误'))
          }
          callback()
        }, 300)
      } else {
        callback()
      }
    }
    return {
      tab: ['项目奖查询', '个人奖查询'],
      active: 0,
      awardInfo: {
        // 项目奖
        projectCode: '',
        projectRadio: '',
        projectUnit: '',
        projectName: '',
        projectYear: '',
        // 个人奖
        personalCode: '',
        personalName: '',
        personalUnit: '',
        personalYear: '',
        loading: false
      },
      rules: {
        projectCode: [{ validator: validateProjectCode, trigger: 'blur' }],
        personalCode: [{ validator: validatePersonalCode, trigger: 'blur' }]
      },
      yearList: [],
      dialogVisible: false,
      list: []
    }
  },
  created() {
    increasedPersonalGetBatchYears({}).then(res => {
      if (res.code == '000') {
        this.yearList = res.result
      }
    })
  },
  methods: {
    handleSearch() {
      if (this.active == 1) {
        if (this.awardInfo.personalCode == '') {
          if (this.awardInfo.personalName == '' && this.awardInfo.personalUnit == '' && this.awardInfo.personalYear == '') {
            this.$message.warning('请输入查询信息')
            return false
          }
          if (this.awardInfo.personalName == '') {
            this.$message.warning('请输入姓名')
            return false
          }
          if (this.awardInfo.personalUnit == '') {
            this.$message.warning('请输入获奖者单位')
            return false
          }
          if (this.awardInfo.personalYear == '') {
            this.$message.warning('请选择申报年份')
            return false
          }
        }
        this.$refs.awardInfo.validateField('personalCode', valid => {
          if (valid) return false
          console.log('个人奖')
          const params = {
            code: this.awardInfo.personalCode,
            name: this.awardInfo.personalName,
            unit: this.awardInfo.personalUnit,
            batchId: this.awardInfo.personalYear
          }
          this.awardInfo.loading = true
          increasedPersonageGetGenerate(params).then(res => {
            this.awardInfo.loading = false
            if (res.code == '000') {
              this.list = res.result
              if (res.result.length > 0) {
                this.dialogVisible = true
              } else {
                this.$message.error('输入信息有误，请重新输入')
                this.dialogVisible = false
              }
            }
          })
        })
      } else {
        if (this.awardInfo.projectCode == '') {
          if (this.awardInfo.projectUnit == '' && this.awardInfo.projectName == '' && this.awardInfo.projectYear == '') {
            this.$message.warning('请输入查询信息')
            return false
          }
          if (this.awardInfo.projectYear == '') {
            this.$message.warning('请选择申报年份')
            return false
          } else {
            if (this.awardInfo.projectRadio == 1) {
              if (this.awardInfo.projectUnit == '') {
                this.$message.warning('请输入完成单位全称')
                return false
              }
            } else {
              if (this.awardInfo.projectName == '') {
                this.$message.warning('请输入完成人全称')
                return false
              }
            }
          }
        }
        this.$refs.awardInfo.validateField('projectCode', valid => {
          if (valid) return false
          console.log('项目奖')
          const params = {
            code: this.awardInfo.projectCode,
            type: this.awardInfo.projectRadio,
            name: this.awardInfo.projectRadio == 1 ? this.awardInfo.projectUnit : this.awardInfo.projectName,
            batchId: this.awardInfo.projectYear
          }
          this.awardInfo.loading = true
          increasedProjectGetGenerate(params).then(res => {
            this.awardInfo.loading = false
            if (res.code == '000') {
              this.list = res.result
              if (res.result.length > 0) {
                this.dialogVisible = true
              } else {
                this.$message.error('您输入信息有误，请重新输入')
                this.dialogVisible = false
              }
            }
          })
        })
      }
    },
    switchover(index) {
      if (index == this.active) return false
      this.active = index
      this.$refs.awardInfo.resetFields()
      this.awardInfo.projectCode = ''
      this.awardInfo.projectUnit = ''
      this.awardInfo.projectName = ''
      this.awardInfo.projectRadio = ''
      this.awardInfo.projectYear = ''
      this.awardInfo.personalName = ''
      this.awardInfo.personalUnit = ''
      this.awardInfo.personalYear = ''
      this.awardInfo.personalCode = ''
    },
    handleInput(val) {
      this.awardInfo.projectUnit = ''
      this.awardInfo.projectName = ''
      this.awardInfo.projectYear = ''
    }
  }
}
</script>

<style lang="less" scoped>

.award {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url(../assets/images/login.jpg) no-repeat;
  background-size: cover;
  .award-contanier {
    width: 500px;
    padding: 10px 50px 20px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 6px;
    .tab {
      width: 100%;
      display: flex;
      div {
        flex: 1;
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 4px solid rgb(233 233 233);
        box-sizing: border-box;
        cursor: pointer;
        font-size: 18px;
      }
      div.active {
        border-bottom: 4px solid rgb(64 158 255);
      }
    }
  }
  .award-info-contanier {
    width: 600px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 6px;
    .award-info-title {
      padding: 20px 0;
      font-size: 18px;
      text-align: center;
      position: relative;
    }
    .award-info-title::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 10em;
      height: 2px;
      background-color: rgb(64 158 255);
      border-radius: 2px;
    }
  }
  .award-info {
    max-height: 68vh;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;
    .award-info-item {
      margin-bottom: 10px;
      padding: 10px 40px;
    }
    .award-info-item + .award-info-item {
      border-top: 1px dashed #ddd;
      // border-top: 1px dashed red;
    }
  }

  .award-info::-webkit-scrollbar {
    width: 12px;
    height: 4px;
  }
  .award-info::-webkit-scrollbar-thumb {
    border: 4px solid transparent;
    background-clip: padding-box;
    border-radius: 7px;
    background-color: rgb(201,205,212);
  }
}
</style>

<style lang="less">
.award-form {
  .el-form-item {
    // margin-bottom: 18px;
    .el-form-item__label {
      color: #999;
    }
    .span {
      word-break: break-all;
    }
  }
  .el-form-item__label,.el-form-item__content {
    line-height: 32px;
  }
}
</style>
